"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cached = void 0;
const createCacheKey_1 = require("../utils/createCacheKey");
function Cached(timeInSeconds = Infinity, cacheFailures = false) {
    return function (target, propName, descriptor) {
        const origFn = descriptor.value;
        descriptor.value = async function (...params) {
            const cacheKey = createCacheKey_1.createCacheKey(propName, params);
            const cachedValue = this.getFromCache(cacheKey);
            if (cachedValue) {
                return cachedValue;
            }
            const result = await origFn.apply(this, params);
            if (result != null || cacheFailures) {
                this.setCache(cacheKey, result, timeInSeconds);
            }
            return result;
        };
        return descriptor;
    };
}
exports.Cached = Cached;
//# sourceMappingURL=Cached.js.map